import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import { loggedInStatus, user } from '../components/generic/reducers.js';

const rootReducer = combineReducers({
    loggedInStatus: loggedInStatus,
    user: user,
    reportCategories: (state = [], action) => {return state},
    routing: routerReducer
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/core/reducers.js